import axios from 'axios';
import store from './store';
import router from './router';
import Vue from 'vue';

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

instance.interceptors.request.use((request) => {
  if (store.getters.token) {
    request.headers.common['Authorization'] = `Bearer ${store.getters.token}`;
    request.headers.common['Content-Type'] = 'application/json';
  }
  return request;
});

instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  async function (error) {
    if (error.response.status === 403) {
      router.push('/dashboard');
    }
    if (error.response.status === 401) {
      await store.dispatch('logout');
    }
    return Promise.reject(error);
  }
);

export default instance;
